import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Radio, RadioGroup, Stack } from '@chakra-ui/react';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toggleSecurityModal, unrestrictDictionary } from '../../../../actions/dictionary-values';
import { Button } from '../../../../components/button/button';
import { ModalComponent } from '../../../../components/Modal/modal';
import { ButtonVariant } from '../../../../core/enums';
import { styles } from './security-modal.styles';
export const SecurityModal = (props)=>{
    const { isDictionaryUnrestricted, onUnrestrictChange, dictionaryId } = props;
    const dispatch = useDispatch();
    const [unrestrictedSelected, updateUnrestrictedSelected] = useState(isDictionaryUnrestricted === null ? false : isDictionaryUnrestricted);
    const _handleClose = ()=>{
        dispatch(toggleSecurityModal(false));
    };
    const _handleToggleRestricted = ()=>{
        updateUnrestrictedSelected(!unrestrictedSelected);
    };
    const _handleApply = ()=>{
        onUnrestrictChange();
        dispatch(unrestrictDictionary(dictionaryId));
        _handleClose();
    };
    const classes = styles();
    return /*#__PURE__*/ _jsx(ModalComponent, {
        size: 'xl',
        showCloseIcon: true,
        isOpen: true,
        handleClose: _handleClose,
        modalHeader: /*#__PURE__*/ _jsx("div", {
            children: "Security Settings"
        }),
        modalContent: /*#__PURE__*/ _jsxs(Flex, {
            flexDirection: 'column',
            rowGap: 5,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: "These settings control which parts of the application are accessible. By default, dictionaries are restricted."
                }),
                /*#__PURE__*/ _jsx(RadioGroup, {
                    name: "restricted",
                    onChange: _handleToggleRestricted,
                    defaultValue: unrestrictedSelected ? 'Unrestricted' : 'Restricted',
                    children: /*#__PURE__*/ _jsxs(Stack, {
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                style: !unrestrictedSelected ? classes.selected : classes.unselected,
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        style: classes.radioButtonContainer,
                                        children: /*#__PURE__*/ _jsx(Radio, {
                                            size: "md",
                                            value: "Restricted",
                                            colorScheme: "orange",
                                            style: classes.radioButton
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        style: classes.radioDescription,
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                style: classes.radioLabel,
                                                children: "Restricted"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                children: "By default, dictionaries are restricted. Restricted dictionaries serve as lists with read and write access to core application processes."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                style: unrestrictedSelected ? classes.selected : classes.unselected,
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        style: classes.radioButtonContainer,
                                        children: /*#__PURE__*/ _jsx(Radio, {
                                            size: "md",
                                            value: "Unrestricted",
                                            colorScheme: "orange",
                                            style: classes.radioButton
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        style: classes.radioDescription,
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                style: classes.radioLabel,
                                                children: "Unrestricted"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                children: "Unrestricted dictionaries allow read-only access to the user interface of the application. Use this if you need to show values in a dropdown or other UI control."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                unrestrictedSelected ? /*#__PURE__*/ _jsx("div", {
                    style: classes.warning,
                    children: "Warning: This cannot be reversed."
                }) : null
            ]
        }),
        modalFooter: unrestrictedSelected ? /*#__PURE__*/ _jsxs(Flex, {
            flexDirection: 'row',
            columnGap: 3,
            sx: classes.footer,
            children: [
                /*#__PURE__*/ _jsx(Flex, {
                    children: /*#__PURE__*/ _jsx(Button, {
                        label: 'Cancel',
                        onClick: _handleClose,
                        variant: ButtonVariant.SECONDARY
                    })
                }),
                /*#__PURE__*/ _jsx(Flex, {
                    children: /*#__PURE__*/ _jsx(Button, {
                        label: 'Apply',
                        onClick: _handleApply
                    })
                })
            ]
        }) : /*#__PURE__*/ _jsx(Flex, {
            flexDirection: 'row',
            columnGap: 3,
            sx: classes.footer,
            children: /*#__PURE__*/ _jsx(Flex, {
                children: /*#__PURE__*/ _jsx(Button, {
                    label: 'Close',
                    onClick: _handleClose,
                    variant: ButtonVariant.SECONDARY
                })
            })
        })
    });
};
